// extracted by mini-css-extract-plugin
export var background = "styles-module--background--a7416";
export var caret = "styles-module--caret--a686a";
export var exam = "styles-module--exam--2b565";
export var examLinks = "styles-module--examLinks--58447";
export var examMobile = "styles-module--examMobile--94601";
export var examsDesktop = "styles-module--examsDesktop--e8682";
export var examsMobile = "styles-module--examsMobile--13096";
export var layout = "styles-module--layout--e90cd";
export var mobileLinks = "styles-module--mobileLinks--61871";
export var navBars = "styles-module--navBars--585d2";
export var navLink = "styles-module--navLink--427f6";
export var navigation = "styles-module--navigation--51d88";
export var navigationDesktop = "styles-module--navigationDesktop--4d439";
export var navigationMobile = "styles-module--navigationMobile--6964c";
export var signIn = "styles-module--signIn--f3d02";